import React, { useRef, useState} from 'react';
import firebase from "firebase/app";
import { useCollectionData } from 'react-firebase-hooks/firestore';

import { firestore, auth } from '../App';
import ChatMessage from "./ChatMessage";
import { Button,  Segment} from 'semantic-ui-react'
// import deepai from "deepai";
import axios from 'axios';

import './components.css';
import MenuItem from './MenuItems';

function ChatRoom({UpdateScore, score, scores}) {
  const dummy = useRef();
  const messagesRef = firestore.collection('messages');
  const query = messagesRef.orderBy('createdAt', "desc").limit(25); // limit 25 but below I reverse the list
  const [messages] = useCollectionData(query, { idField: 'id' });

  const [formValue, setFormValue] = useState('');
  const [AIvalue, setAIValue] = useState('Hey There!');
  //const [currentdocRef, UpdateCurrentdocRef] = useState("");
  const docRef = "";
  

  const sendMessageHUMAN = async (e) => {

    const { uid} = auth.currentUser;
    const { displayName} = auth.currentUser;
    
    await messagesRef.add({
      docRef : docRef,
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      isAI: "no",
      nick: displayName,
      guessedAI: 0,
      guessedHuman: 0
    }).then(function(docRef){
      docRef =  docRef.id;
      messagesRef.doc(docRef).set({docRef : docRef}, { merge: true });
      
    });
    
    setFormValue('');
    dummy.current.scrollIntoView({ behavior: 'smooth' });
  };

  const sendMessageAI = async (e) => {

    const { uid} = auth.currentUser;
    const { displayName} = auth.currentUser;

    console.log(messages[0]["text"]);

    var latestPost = messages[0]["text"];
    if (latestPost === "") {
      latestPost = " Nice to chat with you."
    }
    var body = {
	
      "user_text" : latestPost
    };
    const response = await axios.post('https://whoamaiapinew.herokuapp.com/generate', body)
    setAIValue(response.data.text_response);
    

    await messagesRef.add({
      docRef : docRef,
      text: AIvalue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      isAI: "yes",
      nick: displayName,
      guessedAI: 0,
      guessedHuman: 0
    }).then(function(docRef){
      docRef =  docRef.id;
      messagesRef.doc(docRef).set({docRef : docRef}, { merge: true });
    });


    setFormValue('');
    dummy.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (<>
      
      <Segment  className = "chatbot" style ={{background : "#1e1e24", maxHeight : 800}}>
      
        {messages && messages.map(msg => <ChatMessage key={msg.id} message={msg} UpdateScore={UpdateScore} />).reverse()}
        
        <span ref={dummy}></span>
        
      </Segment>
      <MenuItem score = {score} scores={scores}>
      
      </MenuItem>
      <div className = "below">
      <input  style = {{fontSize: 16}} value={formValue} onChange={(e) => setFormValue(e.target.value)} placeholder="Say something and click send or let AI write for you." />
        <Button type="submit" disabled={!formValue} onClick={sendMessageHUMAN}>SEND</Button>
        <Button  type="submit" disabled={formValue} onClick={sendMessageAI} >AI</Button>

        </div>
  </>);
}

export default ChatRoom;